import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Box, Typography, Container } from '@mui/material';

import Page from '../Page';
import { MotionContainer, varBounce } from '../animate';
import MotivationIllustration from '../../assets/illustration_motivation';
import { getString } from '../../functions/getString';

const RootStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%)',
}));

const CardStyle = styled(Box)(({ theme }) => ({
    maxWidth: 620,
    margin:'auto',
    padding: theme.spacing(5),
    boxShadow: '0 24px 48px rgba(0, 0, 0, 0.08)',
    textAlign: 'center',
}));

const DomainDoesnotExist = ({ error }) => {
    return (
        <Page title={getString('Domain does not exist')}>
            <RootStyle>
                <Container component={MotionContainer}>
                    <CardStyle>
                        <m.div variants={varBounce().in}>
                            <Typography variant="h3" color="primary" gutterBottom  sx={{ fontWeight: 700 }}>
                                {error ? error : "Domain doesn't exist"}
                            </Typography>
                        </m.div>

                        <m.div variants={varBounce().in}>
                            <Typography   variant="body1"  color="text.secondary" sx={{ mb: 4 }}>
                                The domain you are trying to access is not available,
                                inactive, or has been removed. Please verify the domain
                                name or contact the administrator.
                            </Typography>
                        </m.div>

                        <m.div variants={varBounce().in}>
                            <MotivationIllustration sx={{  height: 240,mx: 'auto'}}
                            />
                        </m.div>
                    </CardStyle>
                </Container>
            </RootStyle>
        </Page>
    );
};

export default DomainDoesnotExist;

